
import {defineComponent, PropType} from 'vue'
import BaseTitle from '@/components/UI/BaseTitle.vue'
import BaseOffcanvasButtonClose from '@/components/UI/Bootstrap/Offcanvas/BaseOffcanvasButtonClose.vue'
import {FormMixin} from '@/components/base/FormMixin'
import GenericFormWrapper from '@/components/base/GenericFormWrapper.vue'
import InputText from '@/components/UI/InputText.vue'
import InputSelect from '@/components/UI/InputSelect.vue'
import InputTextEditor from '@/components/UI/InputTextEditor.vue'
import LabelsInput from '@/components/UI/Bootstrap/LabelsInput.vue'
import {PageDetailModeEnum} from '@/models/enum/PageDetailModeEnum'
import {CodeDescriptionRestDto} from '@/api/pharma-master-mailing-template-library/models'
import {MailingMailTemplateRestService} from '@/services/rest/master/MailingMailTemplateRestService'
import {I18nContext} from '@/context/I18nContext'
import {EnumRestService} from '@/services/rest/enum/EnumRestService'
import {EnumClassNameMasterEnum} from '@/models/enum/EnumClassNameMasterEnum'
import {
  MailingMailTemplateRestDtoModel
} from "@/models/api/pharma-master-mailing-template-library/MailingMailTemplateRestDtoModel";

export default defineComponent({
  name: 'MailingMailTemplateDetail',
  mixins: [FormMixin],
  components: { BaseTitle, BaseOffcanvasButtonClose, GenericFormWrapper, InputText, InputSelect, InputTextEditor, LabelsInput },
  emits: ['updated'],
  props: {
    mailingMailTemplateId: {
      type: String as PropType<string | undefined>,
      required: false
    },
    mode: {
      type: String,
      required: true
    },
    moduleCode: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      template: MailingMailTemplateRestDtoModel.createWithDefaults(),
      seasonOptions: [] as CodeDescriptionRestDto[],
      languageOptions: [] as CodeDescriptionRestDto[],
    }
  },
  mounted() {
    this.initialize();
  },
  computed: {
    PageDetailModeEnum() { return PageDetailModeEnum },
  },
  methods: {
    async doInitialize(): Promise<void> {
      this.languageOptions = (I18nContext.getLanguages() || []).map((l: string) => ({code: l, description: l}));
      const serverSeasons = await EnumRestService.getInstance()
        .getEnumValuesByClassName(EnumClassNameMasterEnum.SEASON, this.moduleCode);
      this.seasonOptions = [
        { code: null, description: this.$t('none') as string },
        ...serverSeasons
      ];
    },
    async doReload(): Promise<void> {
      if (this.mode === PageDetailModeEnum.EDIT && this.mailingMailTemplateId) {
        this.template = await MailingMailTemplateRestService.getInstance().getMailingMailTemplate(this.mailingMailTemplateId, this.moduleCode);
      } else {
        this.template = MailingMailTemplateRestDtoModel.createWithDefaults();
      }
    },
    async doSubmit(): Promise<void> {
      // // client-side validations
      // TODO: is this necessary?
      // if (!this.template.labels || this.template.labels.length === 0) {
      //   throw new Error(this.$t('validationAtLeastOneLabel') as string);
      // }
      if (this.mode === PageDetailModeEnum.NEW) {
        await MailingMailTemplateRestService.getInstance().createMailingMailTemplate(this.template, this.moduleCode);
      } else {
        await MailingMailTemplateRestService.getInstance().updateMailingMailTemplate(this.mailingMailTemplateId!, this.template, this.moduleCode);
      }
    },
    async afterSave(): Promise<void> {
      this.$emit('updated');
      this.closeOffCanvas();
    }
  }
})
